import React from "react";
import { Chip, Avatar, Typography } from "@mui/material";
import { limitString } from "../../../../../util";

type AgentChipProps = {
  agent: Agent;
  onClick?: (v: Agent) => void;
  isSelected?: boolean;
  formatter?: (v: string) => string;
};

export default function AgentChip({
  agent,
  onClick,
  isSelected,
  formatter,
}: AgentChipProps) {
  return (
    <Chip
      key={agent.id}
      //   icon={<GroupIcon />}
      onClick={() => onClick && onClick(agent)}
      avatar={
        <Avatar sx={{ bgcolor: agent.color, color: "#fff" }}>
          <Typography
            variant="caption"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              lineHeight: 1,
            }}
          >
            {(() => {
              const [namePart] = agent.email.split("@");
              const parts = namePart.split(".");
              if (parts.length === 1) return parts[0][0].toUpperCase();
              return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
            })()}
          </Typography>
        </Avatar>
      }
      variant={agent.shared ? "outlined" : "filled"}
      sx={{
        background: "rgba(0, 0, 0, 0.08)",
        border: isSelected ? "1px solid blue" : "none",
        height: "50",
        justifyContent: "flex-start",
        "& .MuiChip-label": {
          whiteSpace: "normal",
          display: "block",
          lineHeight: 1.2,
          textAlign: "left",
        },
      }}
      label={formatter ? formatter(agent.email) : agent.email}
    />
  );
}
